<template>
	<section :id="['container-' + index + '-' + fileData.type]" :class="['container-' + fileData.type]">
		<div class="container-xl">
			<div class="row">
				<div class="files-title col-12">
					<h2 v-if="fileData.config.title">{{ fileData.config.title }}</h2>
				</div>
			</div>
		</div>
	
		<div class="container-fluid">
			<div class="file-element">
				<div class="container-xl">
					<div class="row gy-5 justify-content-center">
						<div class="file col-sm-6 col-md-6 col-lg-4" v-for="(file, index) in fileData.config.files" :key="index">
							<a :href="`${file.url}`" :title="`${file.caption}`" target="_blank">
								<span class="file-label">{{ file.caption }}</span>
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="share" class="svg-inline--fa fa-share fa-w-16 file-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path fill="#fff" d="M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"></path></svg>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		fileData: {
			type: Object,
		},
		index: {
			type: Number
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/fileComponent.scss";
</style>
